import DialerStore from './dialerStore'

let dialerStore = new DialerStore()

export default {
  dialerStore
}